<template>
    <pendo-modal
        height="auto"
        :visible="visible"
        :title="`Delete ${attachmentType}?`"
        :confirm-button-config="{
            'type': 'danger',
            'label': `Delete ${attachmentType}`,
            'theme': 'app',
            'loading': deleting,
            'data-cy': 'attachment-delete-button',
        }"
        :cancel-button-config="{ type: 'secondary', theme: 'app', label: 'Cancel' }"
        @close="$emit('closed')"
        @cancel="$emit('closed')"
        @confirm="$emit('delete')">
        <template #body>
            Are you sure you want to delete this {{ attachmentType }} from the {{ vocItemType }} '{{ vocItemTitle }}'?
        </template>
    </pendo-modal>
</template>

<script>
import { PendoModal } from '@pendo/components';

export default {
    components: {
        PendoModal,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        deleting: {
            type: Boolean,
            default: false,
        },
        attachmentType: {
            type: String,
            required: true,
        },
        vocItemTitle: {
            type: String,
            required: true,
        },
        vocItemType: {
            type: String,
            default: 'idea',
        },
    },
    emits: ['closed', 'delete'],
};
</script>
